<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

withDefaults(
  defineProps<{
    hasDepartmentBillingInformation?: boolean
  }>(),
  {
    hasDepartmentBillingInformation: false,
  },
)
</script>

<template>
  <Input id="company-name" name="name" :label="t('tocco.registration.company.name')" :required="true" />

  <div v-show="hasDepartmentBillingInformation" class="form-section--2-cols">
    <Input
      id="company-department"
      name="department"
      :label="t('tocco.registration.conference.invoiceAddress.department')"
      :required="false"
    />
    <Input
      id="company-billing-information"
      name="billing_information"
      :required="false"
      :label="t('tocco.registration.conference.invoiceAddress.billing_information')"
    />
  </div>

  <Address />
</template>
